export const MAX_HALF_KERNEL_SIZE = 16

export const computeKernel = (halfKernelSize: number, sigma: number): number[] => {
    // compute Gaussian kernel
    halfKernelSize = Math.ceil(halfKernelSize)
    const kernel = []
    let sum = 0
    for (let i = -halfKernelSize; i <= halfKernelSize; i++) {
        const v = Math.exp((-i * i) / (2 * sigma * sigma))
        kernel.push(v)
        sum += v
    }
    // make area under curve equal to 1
    for (let i = 0; i < kernel.length; i++) {
        kernel[i] /= sum
    }
    return kernel
}
